import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { defaultNS, useTranslation } from "@/lib/i18n";
import { useEffect, useRef, useState } from "react";

interface InputMonthProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
}

const InputMonth = ({
  value,
  onChange,
  placeholder,
  disabled = false,
  className,
}: InputMonthProps) => {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: "component.inputMonth",
  });

  const months: { value: string; label: string }[] = [
    { value: "1", label: t("january") },
    { value: "2", label: t("february") },
    { value: "3", label: t("march") },
    { value: "4", label: t("april") },
    { value: "5", label: t("may") },
    { value: "6", label: t("june") },
    { value: "7", label: t("july") },
    { value: "8", label: t("august") },
    { value: "9", label: t("september") },
    { value: "10", label: t("october") },
    { value: "11", label: t("november") },
    { value: "12", label: t("december") },
  ];

  // 選択された項目を参照するための ref
  const selectedItemRef = useRef<HTMLDivElement | null>(null);

  // ドロップダウンの開閉状態を管理
  const [open, setOpen] = useState(false);

  // ドロップダウンが開かれたときに選択された項目にスクロールする
  useEffect(() => {
    if (open && selectedItemRef.current) {
      selectedItemRef.current.scrollIntoView({ block: "nearest" });
    }
  }, [open]);

  return (
    <Select
      disabled={disabled}
      onValueChange={onChange}
      value={value}
      open={open}
      onOpenChange={setOpen}
    >
      <SelectTrigger className={className}>
        <SelectValue placeholder={placeholder || t("placeholder")} />
      </SelectTrigger>
      <SelectContent>
        {months.map(({ value: monthValue, label }) => (
          <SelectItem
            key={monthValue}
            value={monthValue}
            ref={monthValue === value ? selectedItemRef : null}
          >
            {label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default InputMonth;
